export default class TemplatesDetailsController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.workflows = this.injector.get('Workflows');
        this.stateParams = this.injector.get('$stateParams');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.state = this.injector.get('$state');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.translate = this.injector.get('$translate');

        this.template = null;
        this.loading = true;
        this.editorCancelTrigger = null;
    }

    $onInit() {
        this._loadTemplate();

        this.routeOutCheckDestruct = this.injector.get('$transitions').onBefore(
            {},
            trans => {
                return new Promise((resolve, reject) => {
                    if (!_.isFunction(this.editorCancelTrigger)) {
                        resolve(trans);
                        return;
                    }

                    this.editorCancelTrigger()
                        .then(() => {
                            resolve(trans);
                        })
                        .catch(() => {
                            resolve(false);
                        })
                });
            });

        this.scope.$on('$destroy', () => {
            if (_.isFunction(this.routeOutCheckDestruct)) {
                this.routeOutCheckDestruct();
            }
        });
    }

    handleEditorSave() {
        this._loadTemplate();
    }

    handleEditorCancel() {
        if (_.isFunction(this.routeOutCheckDestruct)) {
            this.routeOutCheckDestruct();
        }

        this.state.go('app.templates.index');
    }

    _decorateBreadcrumb() {
        this.navService.setStateParameters('app.templates.details', {
            id: this.template.id
        });

        this.navService.setBreadcrumbParameters({
            template_name: this.template.name
        });
    }

    _loadTemplate() {
        this.loading = true;

        return this.api.get(`templates/${this.stateParams.id}`)
            .then(({data}) => {
                this.template = data.data;
                this.loading = false;

                this._decorateBreadcrumb();
                this._updateTabs();
            })
            .catch((exception) => {
                this.alert.handle(exception);
            });
    }

    _updateTabs() {
        const actions = this.workflows.getWorkflows('templates::details')
            .filter(workflow => {
                return this.template.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }

                workflow.action = () => {
                    workflow.onClick(this.template, this);
                };

                return workflow;
            });

        this.navService.overrideMainSideNavActions(actions);
    }
}

TemplatesDetailsController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/templates/controllers/pages/details-controller.js